import { type ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';
import { Modal } from './Modal';
import { Button } from './Button';

type ConfirmDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  loading?: boolean;
};

export function ConfirmDialog({
  open, onClose, onConfirm,
  title, description,
  confirmLabel = 'Confirm', cancelLabel = 'Cancel',
  destructive, loading,
}: ConfirmDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      kicker={destructive ? 'Confirm · Destructive' : 'Confirm'}
      size="sm"
      footer={
        <>
          <Button variant="ghost" onClick={onClose} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button
            variant={destructive ? 'danger' : 'primary'}
            onClick={onConfirm}
            loading={loading}
          >
            {confirmLabel}
          </Button>
        </>
      }
    >
      <div className="flex gap-4 py-2">
        {destructive && (
          <div className="shrink-0 h-9 w-9 rounded-sm border border-danger/40 flex items-center justify-center">
            <AlertTriangle size={16} className="text-danger" />
          </div>
        )}
        <div className="text-sm text-text-muted leading-relaxed">{description}</div>
      </div>
    </Modal>
  );
}
